import { useEffect, useRef } from 'react'

import { getIsGretaAIChatProjectsView } from '../../../GretaAIChat.utils.projects'

export function useGretaAIChatUnreadReplies({
  activeChatId,
  checkBalance,
  clearChatUnread,
  handleOpen,
  isMinimized,
  isOpen,
  markChatSettled,
  view,
}) {
  const isActiveChatHiddenRef = useRef(true)

  const isProjectsView = getIsGretaAIChatProjectsView(view)

  useEffect(() => {
    isActiveChatHiddenRef.current = !isOpen || isMinimized || isProjectsView
  }, [isMinimized, isOpen, isProjectsView])

  function handleTurnSettled(chatId, { delivered, isBackground }) {
    markChatSettled(chatId, {
      delivered,
      isBackground: isBackground || isActiveChatHiddenRef.current,
    })

    // The list was already refreshed when the generation settled.
    if (delivered) {
      checkBalance()
    }
  }

  function handleOpenPanel() {
    handleOpen()

    if (!isProjectsView) {
      clearChatUnread(activeChatId)
    }

    checkBalance()
  }

  return { handleOpenPanel, handleTurnSettled }
}
